import React, { useState } from 'react';
import './SuscripcionesPacks.css';
import { useTranslation } from 'react-i18next';
import { IconPremium } from '../../components/Icons';
import { IconCkeckSolid } from '../../components/Icons/IconCkeckSolid';
import { ProductChildViewModel } from '../../api';
import { postApiNotificationRequestCorporatePack } from '../../api/interconectar-api';
import CircularLoading from '../../shared/CircularLoading/CircularLoading';
import { IconHelp } from '../../components/Icons/IconHelp';

// Definimos el tipo de las props
interface StepProps {
	setStep: (number: number) => void;
	setIsOpenCorp: (boolean: boolean) => void;
	setIsCheckOut: (boolean: boolean) => void;
	setIsOpen: (boolean: boolean) => void;
	data: ProductChildViewModel[];
	setProductId: (id: number) => void;
	productIdsUses: number[];
	productParentName: string;
	onBackToPopup?: () => void;
}

export const SuscripcionesPacks = ({
	setStep,
	setIsOpen,
	setIsOpenCorp,
	setIsCheckOut,
	data,
	setProductId,
	productIdsUses,
	productParentName,
	onBackToPopup,
}: StepProps) => {
	const { t } = useTranslation();
	const [isLoading, setIsLoading] = useState(false);

	const handleOpenCheckOut = (productId: number) => {
		setIsCheckOut(true);
		setStep(2);
		setProductId(productId);
	};
	const handleOpenCorp = async (productParentName: string) => {
		const userId = localStorage.getItem('userId');
		const productName = productParentName === 'Price Calculator' ? 'PriceCalculator' : 'PriceComparator';

		if (!userId) {
			return;
		}

		try {
			setIsLoading(true);
			const result = await postApiNotificationRequestCorporatePack({
				userId: userId,
				product: productName,
			});

			if (result) {
				setIsOpenCorp(true);
				setIsOpen(false);
			}
		} catch (error) {
			console.error('Error requesting corporate pack:', error);
		} finally {
			setIsLoading(false);
		}
	};

	console.log(data);

	if (isLoading) {
		return (
			<div className="packs_loading">
				<CircularLoading />
			</div>
		);
	}

	return (
		<>
			<div className="packs">
				<div className="packs_header">
					<div className="packs_header_left">
						<h2 className="packs_title">
							{productParentName === 'Price Calculator'
								? t('suscripcion.modal_packs.title_calculadora')
								: t('suscripcion.modal_packs.title_comparador')}
							<span className="packs_title_label">
								<IconPremium className="packs_title_label_icon" />{' '}
							</span>
						</h2>
						<p className="packs_subtitle">
							{productParentName === 'Price Calculator'
								? t('suscripcion.modal_packs.description_calculadora')
								: t('suscripcion.modal_packs.description_comparador')}
						</p>
					</div>
					<div className="packs_header_right">
						<button
							type="button"
							className="packs_header_button"
							onClick={() => onBackToPopup?.()}>
							{t('suscripcion.modal_packs.button_why_pro')}

							<IconHelp
								className="packs_header_button_icon"
								fill="#ECEEEF"
								width={15}
								height={15}
							/>
						</button>
					</div>
				</div>
				<div className="packs_body">
					<div className="packs_items">
						{data.map((plan) => {
							const isCorpoPlan = plan.name === 'Corporativo' || plan.name === 'Personalizado';
							return (
								<div
									key={plan.id}
									className={`packs_item ${isCorpoPlan ? 'packs_item--grey' : ''}`}>
									<div className="packs_items_top">
										<h3 className="packs_items_title">{plan.name}</h3>
										<p className="packs_items_desc">
											{plan.uses && plan.uses.includes('>') ? '+50 ' : plan.uses}{' '}
											{productParentName === 'Price Calculator' && t('suscripcion.modal_packs.calculations')}
										</p>
									</div>
									<div className="packs_items_bottom">
										{!isCorpoPlan ? (
											<div className="packs_items_info">
												<div className="packs_unique">
													<p className="packs_unique_title">{t('suscripcion.modal_packs.pack_unique')}</p>
													<p className="packs_unique_price">{plan.price} USD</p>
												</div>
											</div>
										) : (
											<div className="packs_unique"></div>
										)}
										<button
											type="button"
											className={`packs_items_button ${isCorpoPlan ? 'packs_items_button--grey' : ''}`}
											onClick={
												productIdsUses.includes(plan.id ?? 0)
													? undefined
													: isCorpoPlan
														? () => handleOpenCorp(productParentName)
														: () => handleOpenCheckOut(plan.id || 0)
											}
											disabled={isLoading}>
											{isCorpoPlan
												? t('suscripcion.modal_packs.button_consult')
												: t('suscripcion.modal_packs.button_buy')}
										</button>
									</div>

									{/* Para desactivar los ya usados */}
									{productIdsUses.includes(plan.id ?? 0) && (
										<div className="packs_item_overflow">
											<div className="packs_item_overflow_circle">
												<IconCkeckSolid className="packs_item_svg" />
											</div>
										</div>
									)}
								</div>
							);
						})}
					</div>
				</div>
				{productParentName === 'Price Calculator' ? (
					<div
						className="packs_footer"
						dangerouslySetInnerHTML={{ __html: t('suscripcion.modal_packs.footer_calculadora') }}
					/>
				) : (
					<div
						className="packs_footer"
						dangerouslySetInnerHTML={{ __html: t('suscripcion.modal_packs.footer_comparador') }}
					/>
				)}
			</div>
		</>
	);
};
